import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  DialogTitle: {
    backgroundColor: theme.palette.gray.main,
    color: 'white',
  },
  Dialog: {
    '& .MuiDialog-container .MuiDialog-paper': {
      borderRadius: '15px',
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiDialog-container .MuiDialog-paper': {
        marginLeft: '1%',
        marginRight: '1%',
      },
    },
  },
  DialogContent: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  prepayDetail: {
    margin: 'auto',
    display: 'flex',
    gap: 5,
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  avatarHappy: {
    width: '80px',
    [theme.breakpoints.down('md')]: {
      width: '70px',
    },
  },
}));

export const styles = {
  boxContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2.5,
    marginBlock: 2,
    textAlign: 'center',
    paddingInline: { xs: 0, sm: 5 },
    minWidth: {
      xs: '80vw', sm: '270px', md: '350px', lg: '400px',
    },
  },
};

export default useStyles;
